import useNavigateWithPreservedSearchParams from '@/hooks/use-navigate-with-preserved-search-params';

import styles from './identifier-field.module.scss';
import { useEyreT } from './strings';

/** Read-only "Email  you@example.com  Edit" box shown above the password field (ChatGPT style). */
const IdentifierField = ({ label, value }: { readonly label: string; readonly value: string }) => {
  const navigate = useNavigateWithPreservedSearchParams();
  const { t } = useEyreT();

  return (
    <fieldset className={styles.field}>
      <legend>{label.charAt(0).toUpperCase() + label.slice(1)}</legend>
      <span className={styles.value}>{value}</span>
      <button
        type="button"
        className={styles.edit}
        onClick={() => {
          navigate(-1);
        }}
      >
        {t('edit')}
      </button>
    </fieldset>
  );
};

export default IdentifierField;
